export const UPDATE_USER = 'UPDATE_USER';
export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const LIST_USERS = 'LIST_USERS';
export const LOAD_USER = 'LOAD_USER';
export const SAVE_USER = 'SAVE_USER';
export const REMOVE_USER = 'REMOVE_USER';
